import React, { useEffect, useState } from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import PropTypes from 'prop-types';
import { useAssignmentContext } from '../../pages/assignments/context';
import moment from 'moment';
import {useGetRetakeSettingsMutation} from '../../features/authentication/persistApiSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import DropDown from '../DropDown/index';

const Index = () => {

  const [getRetakeSettings] = useGetRetakeSettingsMutation();
  const [initialFromValue, setInitialFromValue] = useState('');
  const [initialToValue, setInitialToValue] = useState('');

  const {
    retakesEnabled,
    setRetakesEnabled,
    masteryValue,
    setMasteryValue,
    retakeMode,
    setRetakeMode,
    autoScoreRetries,
    setAutoScoreRetries,
    retakeLimitValue,
    setRetakeLimitValue,
    retakeAvailabilty,
    setRetakeAvailabilty,
    isRetakeTimed,
    setIsRetakeTimed,
    retakeTimedMinute,
    setRetakeTimedMinute,
    retakeTimedHour,
    setRetakeTimedHour,
    retakeStartDate,
    setRetakeStartDate,
    retakeEndDate,
    setRetakeEndDate,
    retakeQuestion,
    setRetakeQuestion,
    includeCR,
    setIncludeCR,
    isStudentsAssigned
  } = useAssignmentContext();
  
  const getRetakeSettingsAsync = async() => {
    const retakeSettings = await getRetakeSettings().unwrap();
    setMasteryValue(retakeSettings.masteryLevel);
    setRetakeMode(retakeSettings.mode == 'openramode2' ? 'open' : 'quiz');
    setAutoScoreRetries(retakeSettings.retakeRetryScoring);
    setRetakeLimitValue(retakeSettings.limit);
    setRetakeAvailabilty(retakeSettings.availability == 'raalways2' ? 'always': 'fromto');
    setIsRetakeTimed(retakeSettings.timed);
    const timedHours = isNaN(Math.floor(retakeSettings.timeSpan / 60)) ? 0 : Math.floor(retakeSettings.timeSpan / 60);
    const timedMinutes = isNaN(retakeSettings.timeSpan % 60) ? 0 : retakeSettings.timeSpan % 60;
    setRetakeTimedMinute(timedMinutes == 0 ? 45 : timedMinutes);
    setRetakeTimedHour(timedHours);
    setIncludeCR(retakeSettings.includeCR == null ? -1 : (retakeSettings.includeCR ? 1 : 0));
    setRetakeQuestion(retakeSettings.autoGradeQuestions);
    onChangeInitializeToFrom();
  };

  const crQuestions = [
    {
      id: -1,
      name: 'Select an option'
    },
    {
      id: 0,
      name: 'Do not include any CR Questions'
    },
    {
      id: 1,
      name: 'Include CR Questions where MAX score was not achieved'
    }
  ];
  const autoGradeQuestionsToIncludeArr = [
    {
      id: -1,
      name: 'Select an option'
    },
    {
      id: 0,
      name: 'Exact Same Questions as Original Assignment'
    },
    {
      id: 1,
      name: 'Questions Answered Incorrectly the 1st Time'
    },
    {
      id: 2,
      name: 'Questions Answered Incorrectly after Retry'
    }
  ];

  const onSliderChange = (value) => {
    setMasteryValue(value);
  };

  const handleDateChange = (value, type) => {
    if (value != null){
      const date = moment(value).format('YYYY/MM/DD h:mm A');
      if (type === 'from') {
        setRetakeStartDate(date);
        setInitialFromValue(value);
      }
      if (type === 'to') {
        setRetakeEndDate(date);
        setInitialToValue(value);
      }
    }
  };
  

  const onChangeInitializeToFrom = () => {
    var fromDateTime = new Date();
    fromDateTime.setHours(1);
    fromDateTime.setMinutes(0);
    var toDateTime = new Date();
    toDateTime.setHours(23);
    toDateTime.setMinutes(59);
    setInitialFromValue(fromDateTime);
    setInitialToValue(toDateTime);
  };

  useEffect(() => {
    getRetakeSettingsAsync();
  }, []);

  useEffect(() => {
    setRetakeStartDate(initialFromValue);
    setRetakeEndDate(initialToValue);
  }, [initialFromValue, initialToValue]);

  
  const scoreRetries = [
    { label: 'Score with retries as no credit', value: 0 },
    { label: 'Score with retries as half credit', value: 1 },
    { label: 'Score with retries as full credit', value: 2 },
  ];

  return (
    <>
      <div className="assign-options mt-3">
        <span>Retake Assignment Options</span>
      </div>
      <div className='align-items-center d-flex mt-3'>
        <div className="fs-6 assign-settings-header">Assign Retakes</div>
        {isStudentsAssigned &&
        <OverlayTrigger
          key="assignedVia"
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Retake options cannot be changed once assignment is assigned.</Tooltip>}>
          <FontAwesomeIcon icon={faCircleQuestion} className="circle-question mx-1" />
        </OverlayTrigger>
        }
      </div>
      <Form.Group className="mt-2" id="retakesEnabledRadioButtonGroup">
        <Form.Check
          inline
          label="Yes"
          name="retakesEnabledRadioGroup"
          type="radio"
          id="yesRetakesRadio"
          checked={retakesEnabled}
          disabled={isStudentsAssigned}
          onChange={() => setRetakesEnabled(true)}
        />
        <Form.Check
          inline
          label="No"
          name="retakesEnabledRadioGroup"
          type="radio"
          id="noRetakesRadio"
          checked={!retakesEnabled}
          disabled={isStudentsAssigned}
          onChange={() => setRetakesEnabled(false)}
        />
      </Form.Group>

      {retakesEnabled && (
        <>
          <div className="my-3 assign-settings-header">
                Mastery Level ({masteryValue})
          </div>
          <div className="sliding-bar pb-3 w-90">
            <Slider
              min={50}
              max={100}
              value={masteryValue}
              onChange={onSliderChange}
              marks={{ 50: 50, 100: 100 }}
            />
          </div>
          <div className="assign-settings-header mt-5 mb-1">Mode for Retakes</div>
          <Form.Group  id="retakeModeRadioButtonGroup">
            <Form.Check
              inline
              label="Open"
              name="retakeModeRadio"
              type="radio"
              id="openRetakesRadio"
              checked={retakeMode == 'open'}
              onChange={() => setRetakeMode('open')}
            />
            <Form.Check
              inline
              label="Quiz"
              name="retakeModeRadio"
              type="radio"
              id="quizModeRadio"
              checked={retakeMode =='quiz'}
              onChange={() => setRetakeMode('quiz')}
            />
          </Form.Group>
          <div className="assign-settings-header mt-3 mb-1">Auto Score Retries</div>
          <Form.Group id="autoScoreRadioButtonGroup">
            {scoreRetries.map((scoreRetry,index)=>(
              <>
                <Form.Check
                  inline
                  label={scoreRetry.label}
                  name="autoScoreRadio"
                  type="radio"
                  id={`scoreRetry${index}`}
                  checked={autoScoreRetries == scoreRetry.value}
                  onChange={() => setAutoScoreRetries(scoreRetry.value)}
                />
              </>
            ))}
          </Form.Group>
          <div className='mt-3'>
            <DropDown
              key='retakeLimit'
              label="Number of Retakes"
              value={[
                { id: -1, name: 'Select an option' },
                ...Array.from({ length: 10 }, (_, i) => ({
                  id: i + 1,
                  name: i + 1
                }))
              ]}
              onChangeHandler={(e) => setRetakeLimitValue(e.target.value)}
              selectedValue={retakeLimitValue}
            />
          </div>
          <div className="assign-settings-header mt-3 mb-1">Availability Options</div>
          <Form.Group id="retakeAvailabilityRadioButtonGroup">
            <Form.Check
              inline
              label="Always"
              name="retakeAvailabilityRadio"
              type="radio"
              id="alwaysRetakesRadio"
              checked={retakeAvailabilty == 'always'}
              onChange={() => setRetakeAvailabilty('always')}
            />
            <Form.Check
              className='m-0'
              inline
              label="From/To"
              name="retakeAvailabilityRadio"
              type="radio"
              id="fromtoRadio"
              checked={retakeAvailabilty =='fromto'}
              onChange={() => setRetakeAvailabilty('fromto')}
            />
            <OverlayTrigger
              key="retakeAvailabilityfromto"
              placement="top"
              overlay={<Tooltip className="custom-tooltip">This date range determines the window during which the student can view and complete retakes (From and To) and the cutoff date (To) for generating retakes.</Tooltip>}>
              <FontAwesomeIcon icon={faCircleQuestion} className="circle-question mx-1" />
            </OverlayTrigger>
          </Form.Group>
          {retakeAvailabilty == 'fromto' && (
            <div className="d-flex gap-5 align-items-center justify-content-between col-10">
              <div className="col-6">
                <div className="my-3 assign-settings-header">From</div>
                <div className="date-time-picker">
                  <DateTimePicker
                    onChange={(value)=> handleDateChange(value, 'from')}
                    value={retakeStartDate}
                    format="MM/dd/yyyy h:mm a"
                    className="d-flex"
                    id="from-date-picker"
                    disableClock={true}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="my-3 assign-settings-header">To</div>
                <div className="date-time-picker">
                  <DateTimePicker
                    onChange={(value) => handleDateChange(value, 'to')}
                    value={retakeEndDate}
                    format="MM/dd/yyyy h:mm a"
                    className="d-flex"
                    id="to-date-picker"
                    disableClock={true}
                  />
                </div>
              </div>
            </div>
          )}
          <div className='mt-3'>
            <Form.Check.Input
              type="checkbox"
              checked={isRetakeTimed}
              onChange={(e) => setIsRetakeTimed(e.target.checked)}
            />
            <Form.Check.Label className="ms-1 position-relative">
              <span>Timed</span>
            </Form.Check.Label>
            <div className={`d-flex mt-2 mb-4 gap-3 ${isRetakeTimed ? '' : 'd-none'}`}>
              <div className='w-100'>
                <DropDown
                  key='retakeTimedHour'
                  label="Hour"
                  value={Array.from({ length: 24 }, (_, i) => ({
                    id: i,
                    name: i
                  }))}
                  onChangeHandler={(e) => setRetakeTimedHour(e.target.value)}
                  selectedValue={retakeTimedHour}
                />
              </div>
              <div className='w-100'>
                <DropDown
                  key='retakeTimedMinute'
                  label="Minutes"
                  value={Array.from({ length: 60 }, (_, i) => ({
                    id: i,
                    name: i
                  }))}
                  onChangeHandler={(e) => setRetakeTimedMinute(e.target.value)}
                  selectedValue={retakeTimedMinute}
                />
              </div>
            </div>
          </div>
          <div className='mt-3'>
            <DropDown
              key='autoGradeQuestions'
              label="Auto Graded Questions to include on Retakes"
              value={autoGradeQuestionsToIncludeArr}
              onChangeHandler={(e) => setRetakeQuestion(parseInt(e.target.value))}
              selectedValue={retakeQuestion}
            />
          </div>
          <div className='mt-3'>
            <DropDown
              key='includeCRQuestions'
              label="CR Questions to include on Retakes"
              value={crQuestions}
              onChangeHandler={(e) => setIncludeCR(e.target.value)}
              selectedValue={includeCR}
            />
          </div>
        </>
      )}
    </>
  );
};

Index.propTypes = {
  allowRetakesOption: PropTypes.bool,
  allowOfflineMode: PropTypes.bool,
  twoColumn: PropTypes.bool,
  headingDescription: PropTypes.bool,
  availabilityRequired: PropTypes.bool,
  modesRequired: PropTypes.bool,
  noColumn: PropTypes.bool,
  randomizedQuestion: PropTypes.bool,
  disabledTextSpeach: PropTypes.bool,
  presetSettingsCallback: PropTypes.func,
  isSelfAssign: PropTypes.bool,
  isAssessment: PropTypes.bool
};
export default Index;
